<div *ngIf="showVerification; else showForm" class="obg-m-sga-set-password-wrapper">
	<obg-bank-id-auth-container [view]="verificationView" (verified)="bankIdVerified()"> </obg-bank-id-auth-container>
</div>

<ng-template #showForm>
	<obg-m-overlay-spinner *ngIf="isLoading$ | async"></obg-m-overlay-spinner>
	<ng-container *ngIf="isDesktop; else mobileTemplate">
		<ng-container *ngTemplateOutlet="progressBar"></ng-container>
		<obg-m-dialog-layout #dialog [titleText]="'sga-set-password.title' | translate">
			<ng-container *ngIf="!isCountdownFinished else countdownFinished">
				<ng-container
					*ngTemplateOutlet="sgaSetPasswordForm; context: { isTooltipDisabled: false }"
				></ng-container>
			</ng-container>
			<ng-container *ngTemplateOutlet="bottom"></ng-container>
		</obg-m-dialog-layout>
	</ng-container>

	<ng-template #mobileTemplate>
		<obg-m-dialog-layout
			#dialog
			[titleText]="'sga-set-password.title' | translate"
			navbar="true"
			[navbarOptions]="navbarOptions"
		>
			<ng-container *ngTemplateOutlet="progressBar"></ng-container>
			<ng-container *ngIf="!isCountdownFinished else countdownFinished">
				<ng-container
					*ngTemplateOutlet="sgaSetPasswordForm; context: { isTooltipDisabled: true }"
				></ng-container>
			</ng-container>
			<ng-container *ngTemplateOutlet="bottom"></ng-container>
		</obg-m-dialog-layout>
	</ng-template>

	<ng-template #sgaSetPasswordForm let-isTooltipDisabled="isTooltipDisabled">
		<span class="ico-password-encrypted"></span>

		<form class="obg-m-sga-set-password-wrapper" [formGroup]="form" novalidate (ngSubmit)="submit()">
			<p [innerHtml]="'sga-set-password.info' | translate"></p>
			<div class="obg-m-sga-set-password-content">
				<mat-form-field class="obg-m-sga-form-field">
					<input
						matInput
						placeholder="{{ 'sga-set-password.account' | translate }}"
						formControlName="email"
						type="email"
					/>
				</mat-form-field>
				<mat-form-field class="obg-m-sga-set-password-field obg-m-sga-form-field">
					<input
						#pass
						matInput
						obgMatTooltip
						[obgMatTooltipDisabled]="isTooltipDisabled"
						[matMenuTriggerFor]="tooltipPassword"
						[placeholder]="'sga-set-password.password' | translate"
						formControlName="newPassword"
						type="password"
						[autofocus]="false"
						test-id="password"
						data-test-id="password"
						autocomplete="new-password"
						required
					/>
					<mat-icon
						class="obg-m-password-toggle"
						matSuffix
						[obgTogglePasswordFor]="pass"
						passClass="ico-hide"
						textClass="ico-show"
					></mat-icon>
				</mat-form-field>

				<obg-password-strength
					*ngIf="isTooltipDisabled && form?.controls.newPassword.dirty"
					[password]="form?.controls.newPassword.value"
					showDetails
				>
				</obg-password-strength>

				<obg-common-validation-renderer
					[input]="form?.controls.newPassword"
					translationPrefix="reset-password.password"
				>
				</obg-common-validation-renderer>

				<mat-menu #tooltipPassword="matMenu" class="obg-m-tooltip">
					<obg-password-strength [password]="form?.controls.newPassword.value" showDetails>
					</obg-password-strength>
				</mat-menu>

				<button
					mat-flat-button
					class="obg-m-sga-set-password-submit"
					color="accent"
					test-id="btn-set-password"
					data-test-id="btn-set-password"
					type="submit"
					[disabled]="!form.valid"
				>
					{{ 'sga-set-password.save' | translate }}
				</button>
			</div>
		</form>
	</ng-template>

	<ng-template #countdownFinished>
		<span class="ico-password-encrypted"></span>
		<div class="obg-m-sga-set-password-wrapper">
			<p [innerHtml]="'sga-set-password.out-of-time' | translate"></p>
			<div class="obg-m-sga-set-password-content">
				<button
					mat-flat-button
					class="obg-m-sga-set-password-account-settings-link"
					color="accent"
					(click)="navigateToAccountSettings()"
					test-id="btn-account-settings"
					data-test-id="btn-account-settings"
				>
					{{ 'account-settings.title' | translate }}
				</button>
			</div>
		</div>
	</ng-template>

	<ng-template #progressBar>
		<obg-countdown-progress-bar [endsOn]="timeoutInMilliSeconds" hideHours (finish)="isCountdownFinished = true">
		</obg-countdown-progress-bar>
	</ng-template>

	<ng-template #bottom>
		<div class="obg-m-sga-set-password-bottom">
			<a (click)="skipDialog()" test-id="btn-skip-dialog" data-test-id="btn-skip-dialog">
				{{ 'sga-set-password.skip' | translate }}
			</a>
			<p [innerHtml]="'sga-set-password.my-account' | translate"></p>
		</div>
	</ng-template>
</ng-template>
